import React, { useContext } from 'react';
import { bool, func, number, string } from 'prop-types';
import { useParams } from 'react-router-dom';
import * as R from 'ramda';

// context
import { DrawerContext } from 'common/drawer/DrawerContext';

// components
import { Box, Button } from '@mui/material';
import { AUTHORIZATION_TYPE } from 'feature/loading-management/utils/const';
import EditPanel from '../../../edit-panel/EditPanel.connector';

const SupplierAuthActions = ({
  active,
  limitType,
  setDialogDetails,
  setForceCloseEditDrawer,
  toggleSupplierAuthActivation,
  productAuthorizationId,
  supplierName,
  productName,
  locationName,
}) => {
  const { viewBy } = useParams();
  const { setDrawerComponentProps } = useContext(DrawerContext);

  const handleEdit = () => {
    setForceCloseEditDrawer(false);
    setDrawerComponentProps({
      Component: props => (
        <EditPanel {...props} productAuthorizationId={productAuthorizationId} viewBy={viewBy} />
      ),
      forceCloseSelector: R.path([
        'loadingManagement',
        'supplierAuthorizations',
        'forceCloseEditDrawer',
      ]),
    });
  };

  const toggleActivationParams = {
    confirmAction: toggleSupplierAuthActivation,
    header: `Turn ${active ? 'Off' : 'On'} Supplier Authorization?`,
    message: `Turn ${
      active ? 'off' : 'on'
    } ${productName} loading for ${supplierName} at ${locationName}? Supplier Authorizations can be turned back ${
      active ? 'on' : 'off'
    } at any time.`,
    params: { active, locationName, productAuthorizationId, productName, supplierName, viewBy },
  };

  const turnOn = () => {
    return (
      <Button fullWidth onClick={() => setDialogDetails(toggleActivationParams)}>
        Turn On
      </Button>
    );
  };

  const turnOff = () => (
    <>
      <Button fullWidth onClick={() => setDialogDetails(toggleActivationParams)} variant="outlined">
        Turn Off
      </Button>
      {limitType !== AUTHORIZATION_TYPE.SELF && (
        <Button fullWidth onClick={() => handleEdit()}>
          Edit
        </Button>
      )}
    </>
  );

  return (
    <Box
      columnGap="16px"
      display="grid"
      gridTemplateColumns={
        !active || limitType === AUTHORIZATION_TYPE.SELF ? '1fr' : 'repeat(2, 1fr)'
      }
      mt={3}
    >
      {active ? turnOff() : turnOn()}
    </Box>
  );
};

SupplierAuthActions.propTypes = {
  active: bool.isRequired,
  limitType: string,
  locationName: string.isRequired,
  productAuthorizationId: number.isRequired,
  productName: string.isRequired,
  setDialogDetails: func.isRequired,
  setForceCloseEditDrawer: func.isRequired,
  supplierName: string.isRequired,
  toggleSupplierAuthActivation: func.isRequired,
};

SupplierAuthActions.defaultProps = {
  limitType: undefined,
};

export default SupplierAuthActions;
